import * as yup from 'yup';

const API = 'MediaPrivateServices';

export const API_MEDIA_UPLOADS_PRIVATE = {
  UPLOAD_FILE: `${API}/UploadFileToCloud`,
  REMOVE_FILE: (p: { filePath: string }) =>
    `${API}/RemoveFileFromCloud?filePath=${encodeURIComponent(p.filePath)}`,
  GET_FILE: (p: { filePath: string }) =>
    `${API}/DownloadFileFromCloud?fileName=${encodeURIComponent(p.filePath)}`,
};

export const schemaCloudUrl = yup
  .string()
  .url()
  .required('rule-required')
  .test('http', 'rule-https', (value) => {
    if (!value) return false;
    return value?.startsWith('http');
  });
